<template>
  <p class="app-balance-info" v-if="currentCustomer.contract.msisdn">
    <slot name="txtBefore"></slot>
    <dyn-slot :slot-data="slotData">
      <slot name="txtBeforeFormattedBalance">Aktueller Kontostand für Ihre Rufnummer <strong>{{currentCustomer.contract.msisdn}}</strong>: </slot>
    </dyn-slot>
    <span class="app-balance-info-formatted-balance">{{formattedBalance}}</span>
    <slot name="txtAfterFormattedBalance"></slot>
    <slot name="txtAfter"></slot>
  </p>
</template>

<script>

import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'
import price from '@/mixins/price'

export default {
  name: 'BalanceInfo',
  mixins: [
    transaction('balanceInfo'),
    price
  ],
  data () {
    return {
      currentCustomer: {
        balance: null,
        contract: {
          msisdn: ''
        }
      }
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query balanceInfo {
        currentCustomer {
          balance
          contract {
            msisdn
          }
        }
      }`, this, 'currentCustomer')
    }
  },
  computed: {
    formattedBalance () {
      if (this.currentCustomer.balance === null) {
        return '-'
      }
      return this.price(this.currentCustomer.balance)
    },
    slotData () {
      return {
        currentCustomer: this.currentCustomer
      }
    }
  }
}
</script>
